import { useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import { FaEye, FaPlus, FaSearch } from "react-icons/fa";
import LoadingComponent from "../../widgets/LoadingComponent";
import { useNavigate } from "react-router-dom";
import { getData } from "../../api/ApiRest";
import { useSelector } from "react-redux";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";

function Soporte() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState([]);

    const [tickets, setTickets] = useState([]);

    const companyId = useSelector((state) => state.auth.CompanyId);

    const navigate = useNavigate();

    useEffect(() => {
        const fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate() - 15);

        setDataBuscar({
            ...dataBuscar,
            FechaIni: fechaActual.toISOString().split('T')[0],
            FechaFin: new Date().toISOString().split('T')[0]
        });
    }, [])

    const buscarTicket = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Soporte/getDataIndex', {
            CompanyId: companyId || '',
            FechaIni: dataBuscar.FechaIni,
            FechaFin: dataBuscar.FechaFin,
            Tipo: dataBuscar.Tipo || '',
            Numero: dataBuscar.NTicket || ''
        }).then(response => {
            setTickets(response.list);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const visualizarTicket = (soporteid) => {
        navigate('/Home/PqrCRUD/' + soporteid);
    }

    ///Función para convertir el estado en letra al texto correspondiente
    const estadoText = (estado) => {
        if (estado === "C")
            return 'Creación';
        else if (estado === "P")
            return 'Proceso';
        else if (estado === 'S')
            return 'Solucionado';
        else if (estado === "R")
            return 'Rechazado';
    }

    const tipo_text = (tipo) => {
        if (tipo === 'T')
            return 'Ticket';
        else if (tipo === 'Ac')
            return 'Acta';
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Home</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>PQR</Breadcrumb.Item>
        </Breadcrumb>

        <Button variant='success' onClick={() => {
            navigate('/Home/PqrCRUD/0');
        }}
            className='mb-2'>
            <FaPlus size={'1rem'} />
        </Button>

        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarTicket}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Inicial"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaIni}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaIni: value.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Final"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaFin}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaFin: value.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="NumTicket"
                        label="N. ticket"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="N Ticket"
                            value={dataBuscar.NTicket}
                            onChange={value => setDataBuscar({ ...dataBuscar, NTicket: value.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId='TipoNewInput'
                        label="Tipo"
                        className="mb-2"
                    >
                        <Form.Select
                            value={dataBuscar.Tipo}
                            onChange={event => {
                                setDataBuscar({ ...dataBuscar, Tipo: event.target.value })
                            }}
                        >
                            <option value="">Seleccione</option>
                            <option value="Ac">Acta</option>
                            <option value="T">Solicitud</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit'>
                        <FaSearch size={'1rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Número
                            </th>
                            <th className="estilo-encabezado">
                                Fecha
                            </th>
                            <th className="estilo-encabezado">
                                Titulo
                            </th>
                            <th className="estilo-encabezado">
                                Tipo
                            </th>
                            <th className="estilo-encabezado">
                                Estado
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tickets.map((item, index) => (
                            <tr key={index} style={{ fontSize: 14 }}>
                                <td className="text-center">
                                    <Button type="button" variant="primary" onClick={() => visualizarTicket(item.soporteid)}
                                        style={{
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            fontSize: 12
                                        }}>
                                        <FaEye />
                                    </Button>
                                </td>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center">
                                    {item.numero}
                                </td>
                                <td className="text-center">
                                    {formatDateddMMMyyyy(item.fecha)}
                                </td>
                                <td className="text-center">
                                    {item.titulo}
                                </td>
                                <td className="text-center">
                                    {item.tipo}
                                </td>
                                <td className="text-center">
                                    {estadoText(item.estado)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}

export default Soporte;